import auth from '@/components/fireAuthInit';
import db from '@/components/firebaseInit'
import router from '@/router'
import spUsers from '@/master/sp_users.json'

const Auths = {
    sp: ['ReadAutoMail',
        'ReadSendMail',
        'ReadCommentQuestions',
        'ReadSelectQuestions',
        'ReadStartEndPage',
        'EditSurveySummary',
        'EditSurveyUsers',
        'EditSurveySchedules',
        'ReadAndEditSurveyResults',
    ],
    manager: [],
    user: []
}
export default {
    namespaced: true,
    state: {   // state.userは常に存在します
        user: undefined, // ユーザー情報を格納する。ログインしてないときはundefined
        errorMessage: "",
        toUrl: "",
    },
    mutations: {
        changeAuthState(state, user) {
            state.user = user;  //受け取ったuserを保存する
        },
        changeErrorMessage(state, e) {
            state.errorMessage = e.message
        },
        saveToUrl(state, url) {
            state.toUrl = url
        },
        clearToUrl(state) {
            state.toUrl = ""
        },

    },
    getters: {
        user(state) {
            return state.user;  //user()が呼ばれると、保存されたユーザー情報を返す
        },
        isLoggedIn(state) {
            return !!state.user
        },
        toUrl(state) {
            return state.toUrl
        },
        auths(state) {
            if (state.user && state.user.role) {
                return Auths[state.user.role]
            } else {
                return []
            }
        }

    },
    actions: {
        logIn({ commit, dispatch }, account) {
            return new Promise((resolve, reject) => {
                auth.signInWithEmailAndPassword(account.email, account.password).then(user => {
                    console.log('Logged In Firebase')
                    
                }).catch((e) => {
                    console.log("Login Error")
                    console.log(e)
                    commit("changeErrorMessage", e)
                    reject(e)
                })
            })


        },
        logOut() {
            console.log('Logged Out')
            auth.signOut()
        },
        Can({ state }, auth) {
            if (state.user && state.user.role) {
                return Auths[state.user.role].indexOf(auth) >= 0 ? true : false
            } else {
                return false
            }

        }
    }
}


export function authInit(store) {
    auth.onAuthStateChanged(async user => {
        let userDoc = null
        
        if (user) {
            // Check if this user is SP user
            const sp = spUsers.filter(sp => {
                return sp.email == user.email
            })
            
            // SP users can login from any company page
            if (sp.length > 0) {
                
                userDoc = await db.collection('companies').doc(sp[0].company_id).collection('users').doc(user.uid).get()
            } else {
                userDoc = await db.collection('companies').doc(router.history.current.params.company_id).collection('users').doc(user.uid).get()
            }
            if (!userDoc.exists) {
                throw new Error("登録されていません。");
            }
            
            const userAppData = { ...userDoc.data(), uid: user.uid }
            
            store.commit("auth/changeAuthState", { ...userAppData, company_id: router.history.current.params.company_id })
            const url = store.getters['auth/toUrl']

            if (url == "") {
                if (userAppData.role == "manager") {
                    router.push({ name: "manage_surveys", params: { company_id: router.history.current.params.company_id } })
                } else if (userAppData.role == "user") {
                    router.push({ name: "home", params: { company_id: router.history.current.params.company_id } })
                } else if (userAppData.role == "sp") {
                    router.push({ name: "companies" })
                }
            } else {
                router.push({ path: url })
                store.commit("auth/clearToUrl")
            }
        }
        else {
            store.commit("auth/changeAuthState", undefined)
        }
    })
}